


















import { defineComponent, nextTick, onMounted, ref, toRef, watch } from "@vue/composition-api";
import { getThumbnailScrollLeft } from "../helpers";

export default defineComponent({
  name: "FullScreenThumbnails",
  props: {
    items: { type: Array, required: true },
    keyName: { type: String, required: true },
    current: { type: Number, default: 0 },
  },
  setup(props) {
    const strip = ref<HTMLElement | null>(null);
    const thumbnails = ref<HTMLElement[]>([]);

    const scrollStrip = (left: number, smooth: boolean) => {
      if (!strip.value) return;
      if (typeof strip.value.scrollTo === "function") {
        strip.value.scrollTo({ left, behavior: smooth ? "smooth" : "auto" });
      } else {
        strip.value.scrollLeft = left;
      }
    };

    // keeps the current thumbnail in the middle of the strip
    const scrollToCurrent = async (smooth = true) => {
      await nextTick();
      const thumbnail = thumbnails.value?.[props.current];
      if (!strip.value || !thumbnail) return;
      const left = getThumbnailScrollLeft({
        stripWidth: strip.value.clientWidth,
        scrollWidth: strip.value.scrollWidth,
        thumbnailLeft: thumbnail.offsetLeft,
        thumbnailWidth: thumbnail.offsetWidth,
      });
      scrollStrip(left, smooth);
    };

    // a mouse wheel without horizontal scroll moves the strip sideways
    const onWheel = (event: WheelEvent) => {
      if (!strip.value || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
      scrollStrip(strip.value.scrollLeft + event.deltaY, false);
      event.preventDefault();
    };

    watch(toRef(props, "current"), () => scrollToCurrent());
    // opened on a far item: the strip starts there without an animation
    onMounted(() => scrollToCurrent(false));

    return { strip, thumbnails, onWheel, scrollToCurrent };
  },
});
